





















import {Vue, Component, Prop, Emit} from 'vue-property-decorator';

@Component
export default class MediaAlert extends Vue {
  @Prop({ default: 'Закрыть' })
  private dismissLabel!: string;

  @Prop({ default: true })
  private dismissible!: boolean;

  @Prop({ default: false })
  private show!: boolean | number | string;

  @Prop({ default: 'info' })
  private variant!: 'info' | 'success' | 'danger' | 'warning';

  @Prop()
  private title!: string;

  @Prop({ default: '' })
  private description: string | undefined;

  @Prop({ default: 'ツ' })
  private smiley!: string;

  @Emit()
  private dismissed() {
    return;
  };
}
